import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';

export default function LandingPage() {
  const navigate = useNavigate();

  return (
    <div 
      className="min-h-screen flex items-center justify-center px-4"
      style={{
        backgroundImage: 'url(https://customer-assets.emergentagent.com/job_1c81aa48-a213-4431-b5e1-0b1e4b49e9d9/artifacts/clc0ly6h_Mega%20Church%20Inside%20LV2%20Church.png)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat'
      }}
    >
      <div className="text-center">
        {/* Mega Church Logo with Animation */}
        <div className="mb-12 animate-logo-entrance">
          <img
            src="https://customer-assets.emergentagent.com/job_mega-church-game/artifacts/9qio0cok_Mega%20Church%20Logo%20T%20Shirt.png"
            alt="Mega Church Logo"
            className="w-64 sm:w-80 md:w-96 mx-auto drop-shadow-2xl animate-logo-float"
          />
        </div>

        {/* Play Now Button - Green */}
        <Button
          onClick={() => navigate('/start')}
          className="w-64 sm:w-80 h-20 text-2xl sm:text-3xl font-black bg-gradient-to-r from-green-500 to-green-700 hover:from-green-600 hover:to-green-800 text-white rounded-2xl shadow-2xl transform hover:scale-105 transition-all duration-300"
          data-testid="play-now-btn"
        >
          PLAY NOW
        </Button>

        {/* Tagline */}
        <p className="mt-8 text-lg sm:text-xl text-white font-semibold drop-shadow-lg">
          Build your congregation by testing your Bible knowledge
        </p>
      </div>
    </div>
  );
}
